import type { ServerEvent } from '~/routes/bolt.event';

type BaseData = { isBot: boolean };

class UserEvent<T extends BaseData> {
  serverEvents: ServerEvent[] = [];

  constructor(protected data: T) {
    return;
  }

  sendServerEvents() {
    if (!this.serverEvents.length || this.data.isBot) return;

    return fetch('/bolt/event', {
      body: JSON.stringify({ events: this.serverEvents }),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST'
    });
  }

  async sendToFacebook() {}

  async sendToTikTok() {}

  async sendToTwitter() {}

  sendToGtm() {}

  sendToAlgolia() {}

  sendToServer() {}

  sendToBraze() {}

  collectServerEvents() {}

  async send() {
    await Promise.all([
      this.sendToFacebook(),
      this.sendToTikTok(),
      this.sendToTwitter(),
      this.sendToGtm(),
      this.sendToAlgolia(),
      this.sendToServer(),
      this.sendToBraze(),
      this.collectServerEvents()
    ]);

    await this.sendServerEvents();
  }
}

export default UserEvent;
